import React, { useContext } from 'react';
import { UserContext } from '../../contexts/UserContext';
import HomeLandscape from './HomeLandscape';
import HomePortrait from './HomePortrait';

function Home() {
  const { userDetails } = useContext(UserContext);

  console.log("Mobile:", userDetails.isMobile, "OS:", userDetails.mobileOS);

  return userDetails.isMobile ? <HomePortrait /> : <HomeLandscape />;
}

export default Home;